/**
 * @hidden
 */
export var DEFAULT_ANIMATION_DURATION = 400;
/**
 * @hidden
 */

export var NO_ANIMATION = 0;